export const USER_REQUEST = 'USER_REQUEST';
export const USER_SUCCESS = 'USER_SUCCESS';
//
export const USER_SUPERIOR_REQUEST = 'USER_SUPERIOR_REQUEST';
export const USER_SUPERIOR_SUCCESS = 'USER_SUPERIOR_REQUEST';
//
export const USER_ERROR = 'USER_ERROR';
//
export const USER_SET_PASSWORD = 'USER_SET_PASSWORD';
export const USER_DISMISS_NOTIFICATION = 'USER_DISMISS_NOTIFICATION';
export const USER_SET_BADGE_NOTIFICATIONS = 'USER_SET_BADGE_NOTIFICATIONS';
export const USER_SET_PLACE = 'USER_SET_PLACE';
export const USER_SET_YEAR = 'USER_SET_YEAR';
export const USER_SET_KNOWLEDGE_ZONE_CATEGORY = 'USER_SET_KNOWLEDGE_ZONE_CATEGORY';
